import { render, staticRenderFns } from "./GuardAuth.vue?vue&type=template&id=06a94b2a"
import script from "./GuardAuth.vue?vue&type=script&lang=js"
export * from "./GuardAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/notification/Notification.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,ErrorSummary: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/error-summary/ErrorSummary.vue').default,Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,DevDebug: require('/home/runner/work/platform/platform/packages/client/src/components/utils/dev-debug/DevDebug.vue').default,FormLogin: require('/home/runner/work/platform/platform/packages/client/src/components/forms/auth/FormLogin.vue').default,LayoutAuth: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/auth/LayoutAuth.vue').default})
